import React from 'react';
import classNames from 'classnames';
import { ArrowLeftIcon, ForbiddenIcon } from '../../../components/Icons';
var BLUE = '#68C2EC';
var GREEN = '#64EB93';
var YELLOW = '#FFCF59';
var ORANGE = '#FF955A';
var RED = '#FF5A6E';
export default function colorPicker(_ref) {
  var editor = _ref.editor;

  function renderColorSquare(color, index) {
    var currentHighlight = editor.query('getActiveHighlight');
    var highlightColor = currentHighlight && (currentHighlight.data.get('color') || GREEN);
    var isSelected = color === highlightColor;
    return React.createElement("div", {
      "data-toolbar": "highlight-color-picker-".concat(index),
      key: index,
      onClick: function onClick() {
        return editor.command('setHighlight', color);
      },
      className: classNames(isSelected ? 'border-medium border-purple' : '', 'radius-normal pointer'),
      style: {
        backgroundColor: "".concat(color, "66"),
        width: 16,
        height: 16
      }
    });
  }

  return React.createElement("div", {
    "data-toolbar": "highlight-color-picker",
    className: "flexbox flexbox-align-center padding-vertical-small width-full flexbox-space-around padding-horizontal-smaller"
  }, React.createElement(ArrowLeftIcon, {
    className: "shade-30 shade-20-on-hover shade-10-on-active pointer",
    size: 16,
    onClick: function onClick() {
      editor.command('closePrompt');
    }
  }), [BLUE, GREEN, YELLOW, ORANGE, RED].map(function (color, index) {
    return renderColorSquare(color, index);
  }), React.createElement(ForbiddenIcon, {
    "data-toolbar": "highlight-color-picker-cancel",
    className: "pointer shade-30 shade-20-on-hover shade-10-on-active",
    onClick: function onClick() {
      return editor.command('removeSelectionHighlights');
    }
  }));
}